var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":_vm.label,"items":_vm.choices,"multiple":_vm.multiple,"value":_vm.value},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }